export const spaceName = 'odDeal';

export interface DealSettings {
  editingId: number;

  originalData: {
    originalBasicInfo: any;
    originSelectedIds: any[];
  };

  currentData: {
    currentSelectedIds: any;
    currentBasicInfo: any[];
  };

  relationData: any;
}

export default {} as DealSettings;

export const getTableColumns = (props: any) => {
  const {
    helper: { txo },
    od: { offeringTypeList, allMenus },
    hideAddOns,
  } = props;

  const offeringTypeFilter = offeringTypeList.map((x: any) => ({
    text: x.tagName,
    value: x.tagName,
  }));
  const menuFilter = allMenus.map((x: any) => ({
    text: x.name,
    value: x.name,
  }));

  return [
    {
      dataIndex: 'name',
      title: txo('Global.product_name'),
      key: 'name',
      width: 130,
      ellipsis: true,
      sorter: hideAddOns ? undefined : (a: any, b: any) => a.price - b.price,
    },
    {
      dataIndex: 'price',
      title: txo('Global.price'),
      key: 'price',
      width: 75,
      sorter: hideAddOns ? undefined : (a: any, b: any) => a.price - b.price,
    },
    {
      dataIndex: 'menu',
      key: 'menu',
      title: txo('Global.menu'),
      ellipsis: true,
      width: 120,
      render: (item: any) => item.map((x: any) => x.name).join(', '),
      sorter: hideAddOns ? undefined : (a: any, b: any) => a.name.localeCompare(b.name),
      filters: hideAddOns ? undefined : menuFilter,
      onFilter: (value: any, record: any) => record.menu.map((x: any) => x.name).includes(value),
    },
    {
      dataIndex: 'offeringType',
      title: txo('Global.offering_type'),
      key: 'offeringType',
      width: 110,
      // filters: offeringTypeFilter,
      // onFilter: (value: any, record: any) => [record.offeringType].indexOf(value) >= 0,
    },
  ];
};
